module.exports = __webpack_public_path__ + "assets/img/27.cb30dd7d.png";